export default {
  'menu.home': 'الصفحة الأولى',
  'menu.chiselDetail': 'إزميل ',
  'menu.otherParts': 'الأجزاء الأخرى',
  'menu.prodTech': 'عملية الإنتاج',
  'menu.service': 'الخدمات',
  'menu.aboutUs': 'بشأننا',
  'menu.exhibitionDetail': 'تفاصيل المعرض'
}
